import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/Global-Services/common.service';

@Component({
  selector: 'app-un-authorize',
  templateUrl: './un-authorize.component.html',
  styleUrls: ['./un-authorize.component.css'],
  standalone: false,
})
export class UnAuthorizeComponent implements OnInit {

  constructor(private gservice: CommonService) { }

  ngOnInit() {
  }
  Login() {
      this.gservice.Login();
  }
}

